(function (window, angular) {
    "use strict";
    var m = angular.module("vvCommon");


    m.config(function ($provide) {
        $provide.decorator('ngSrcDirective', function ($delegate, $sniffer) {
            var directive = $delegate[0];
            directive.compile = function (element, attrs) {
            };
            return $delegate;
        });
    }).directive('ngSrc', function (vv) {
        return function (scope, element, attrs) {
            attrs.$observe('ngSrc', function (value) {
                if (!value)
                    return;

                if (value.indexOf("/api/i/") == 0) {
                    value = vv.getCdnUrl(value);
                }
                attrs.$set('src', vv.adjustProtocol(value));
            });
        };
    }).directive('onErrorSrc', function() {
        return {
            link: function(scope, element, attrs) {
              element.bind('error', function() {
                if (attrs.src != attrs.onErrorSrc) {
                  attrs.$set('src', attrs.onErrorSrc);
                }
              });
            }
        }
    });
})(window, window.angular);
